import { BillsService } from 'services/bills/bills';
import { INVOICE_TYPE } from 'views/BillingPaymentTrack/commons/constants';
import moment from 'moment';

const INVOICE_COLUMNS = ['account number', 'invoice number', 'payment date', 'amount'];
// const INVOICE_ACCOUNT_NUMBER_INDEX = 0;
const INVOICE_INVOICE_NUMBER_INDEX = 1;
const INVOICE_PAYMENT_DATE_INDEX = 2;
const INVOICE_AMOUNT_INDEX = 3;

const ACCOUNT_COLUMNS = ['account number', 'payment date', 'amount'];
const ACCOUNT_ACCOUNT_NUMBER_INDEX = 0;
const ACCOUNT_PAYMENT_DATE_INDEX = 1;
const ACCOUNT_AMOUNT_INDEX = 2;

const excelFileNotEmpty = (file: any[]): boolean => {
	// header + at least one row with data
	return file.length > 1;
};

const areNamesOfColumnsValid = (file: any[], correctColumns: string[]): boolean => {
	const namesOfColumns = Object.values(file[0]);
	return (
		namesOfColumns.length === correctColumns.length &&
		namesOfColumns.every((nameOfColumn, index) => String(nameOfColumn).toLowerCase() === correctColumns[index])
	);
};

const isAccountNumberCorrect = async (file: any[], accountNumberIndex: number): Promise<boolean> => {
	// account number should be the same for every row
	// TODO check if billing account number is correct - use API to get all billing accounts
	const billingAccountIds = await BillsService.getCorpBillingIds().toPromise();
	const userBillingAccountIds = billingAccountIds.billingIds.map((billingId) => billingId.billingId);
	const excelAccountNumbers = file.map((row) => Object.values(row)[accountNumberIndex]).slice(1);
	return (
		excelAccountNumbers.length > 0 &&
		excelAccountNumbers.every((accountNumber) => {
			return userBillingAccountIds.includes(String(accountNumber));
		})
	);
};

const isInvoiceNumberCorrect = (file: any[], invoiceNumberIndex: number): boolean => {
	// invoice number should be not empty number
	const invoiceNumbers = file.map((row) => Object.values(row)[invoiceNumberIndex]).slice(1);
	return invoiceNumbers.every((invoiceNumber) => !!Number(invoiceNumber));
};

const isPaymentDateCorrect = (file: any[], paymentDateIndex: number): boolean => {
	const paymentDates = file.map((row) => Object.values(row)[paymentDateIndex]).slice(1) as string[];
	return (
		paymentDates.length > 0 &&
		paymentDates.every((paymentDate) => {
			const momentPaymentDate = moment(paymentDate, ['DD/MM/YYYY', 'DD-MM-YYYY', 'DD.MM.YYYY'], true);
			return momentPaymentDate.isValid() && momentPaymentDate.isBefore(moment());
		})
	);
};

const isAmountCorrect = (file: any[], amountIndex: number): boolean => {
	// amount should be higher than zero
	const amounts = file.map((row) => Object.values(row)[amountIndex]).slice(1);
	return amounts.every((amount) => Number(amount) > 0);
};

export const isExcelFileValid = async (
	file: any[],
	invoiceType: string
): Promise<{ valid: boolean; error?: string }> => {
	const accountNumberCorrect = await isAccountNumberCorrect(file, ACCOUNT_ACCOUNT_NUMBER_INDEX);
	var formatCorrect = false;
	if (invoiceType === INVOICE_TYPE.ACCOUNT) {
		formatCorrect =
			excelFileNotEmpty(file) &&
			areNamesOfColumnsValid(file, ACCOUNT_COLUMNS) &&
			isPaymentDateCorrect(file, ACCOUNT_PAYMENT_DATE_INDEX) &&
			isAmountCorrect(file, ACCOUNT_AMOUNT_INDEX);
	} else {
		formatCorrect =
			excelFileNotEmpty(file) &&
			areNamesOfColumnsValid(file, INVOICE_COLUMNS) &&
			isInvoiceNumberCorrect(file, INVOICE_INVOICE_NUMBER_INDEX) &&
			isPaymentDateCorrect(file, INVOICE_PAYMENT_DATE_INDEX) &&
			isAmountCorrect(file, INVOICE_AMOUNT_INDEX);
	}
	if (accountNumberCorrect && formatCorrect) {
		return { valid: true };
	} else if (!accountNumberCorrect) {
		return { valid: false, error: 'accountNumber' };
	} else {
		return { valid: false, error: 'format' };
	}
};
